/*! Digital Ummah — interface layer (Digital X).
 * Enhances the Digital Ummah page body (rendered from the page content) without replacing it:
 * new hero + bento tool grid, sticky nav with scroll-spy, scroll reveal, and full BM/EN
 * consistency shared with Digital Quran / Digital Hadith through localStorage 'quran-lang'.
 */
(function () {
  "use strict";
  var du = document.querySelector(".du");
  if (!du || du.getAttribute("data-dxu")) return;
  du.setAttribute("data-dxu", "1");
  du.classList.add("dxu-on");

  var RM = false;
  try { RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}

  function $(id) { return document.getElementById(id); }
  function L() { return window.duLang === 1 ? 1 : 0; } // 0 = EN, 1 = BM
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }

  /* ------------------------------------------------------------------ i18n */
  var T = {
    langGroup: ["Language", "Bahasa"],
    arSub: ["One ummah", "Satu ummah"],
    explore: ["Explore the tools", "Terokai alatan"],
    exploreSub: ["Everything for your day as a Muslim, in one place.", "Segala keperluan harian seorang Muslim, dalam satu tempat."],
    jump: ["Jump to section", "Lompat ke bahagian"],
    toTop: ["Back to top", "Kembali ke atas"],
    prevMonth: ["Previous month", "Bulan sebelumnya"],
    nextMonth: ["Next month", "Bulan seterusnya"],
    openPage: ["Open", "Buka"],
    go: ["Go", "Pergi"],
    ramIn: ["Ramadan in {n} days", "Ramadan dalam {n} hari"],
    ramDay: ["Ramadan · day {n}", "Ramadan · hari ke-{n}"],
    nextPr: ["Next prayer", "Solat seterusnya"],
    setLoc: ["Set your location", "Tetapkan lokasi anda"],
    noTrans: ["Malay translation not available yet for this dua.", "Terjemahan Bahasa Melayu belum tersedia untuk doa ini."],
    tQuran: ["Digital Quran", "Digital Quran"],
    dQuran: ["114 surahs with translation, tafsir and 12 reciters.", "114 surah dengan terjemahan, tafsir dan 12 qari."],
    tHadith: ["Digital Hadith", "Digital Hadith"],
    dHadith: ["16 collections, hadith of the day and topic search.", "16 koleksi, hadis hari ini dan carian topik."],
    tPrayer: ["Prayer Times", "Waktu Solat"],
    dPrayer: ["Live countdown to the next prayer.", "Kiraan detik ke solat seterusnya."],
    tQibla: ["Qibla", "Kiblat"],
    dQibla: ["Live compass pointing to the Kaaba.", "Kompas langsung ke arah Kaabah."],
    tVerse: ["Verse of the Day", "Ayat Hari Ini"],
    dVerse: ["A fresh ayah to reflect on.", "Ayat baharu untuk direnungi."],
    tDua: ["Daily Duas", "Doa Harian"],
    dDua: ["Morning, evening, travel and more.", "Pagi, petang, musafir dan banyak lagi."],
    t99: ["99 Names of Allah", "99 Nama Allah"],
    d99: ["Asma-ul-Husna with meanings.", "Asmaul Husna beserta maksudnya."],
    tNames: ["Muslim Names", "Nama Muslim"],
    dNames: ["Beautiful names and their stories.", "Nama indah dan kisahnya."],
    tCal: ["Islamic Calendar", "Kalendar Islam"],
    dCal: ["Hijri and Gregorian, side by side.", "Hijrah dan Masihi, seiring."],
    tEvents: ["Islamic Events", "Peristiwa Islam"],
    dEvents: ["Key dates in the Hijri year.", "Tarikh penting tahun Hijrah."],
    tRam: ["Ramadan Countdown", "Kiraan Detik Ramadan"],
    dRam: ["Days until the blessed month.", "Hari lagi ke bulan yang mulia."],
    findLbl: ["Search tools", "Cari alatan"],
    findPh: ["Search tools… e.g. zakat, qibla", "Cari alatan… cth. zakat, kiblat"],
    clear: ["Clear search", "Kosongkan carian"],
    noTools: ["No tool matches your search.", "Tiada alatan sepadan dengan carian anda."],
    pin: ["Pin to top", "Sematkan di atas"],
    unpin: ["Unpin", "Nyahsemat"],
    pinned: ["Pinned to the top", "Disematkan di atas"],
    unpinned: ["Unpinned", "Dinyahsemat"],
    contLbl: ["Continue listening", "Sambung mendengar"],
    streak: ["{n}-day streak", "{n} hari berturut-turut"],
    share: ["Share", "Kongsi"],
    shareVerse: ["Share verse", "Kongsi ayat"],
    copied: ["Link copied", "Pautan disalin"],
    copiedVerse: ["Verse copied", "Ayat disalin"],
    shareFail: ["Could not share. Please copy the address bar link.", "Tidak dapat dikongsi. Sila salin pautan di bar alamat."],
    shareText: ["Digital Ummah — prayer times, Quran, hadith, duas and more in one place.", "Digital Ummah — waktu solat, Al-Quran, hadis, doa dan banyak lagi dalam satu tempat."],
    orCity: ["or choose a city", "atau pilih bandar"],
    cityPh: ["Choose a city…", "Pilih bandar…"],
    cityLbl: ["Prayer times for a city", "Waktu solat mengikut bandar"],
    langSet: ["English selected", "Bahasa Melayu dipilih"],
    no99: ["No name matches your search.", "Tiada nama sepadan dengan carian anda."],
    tZakat: ["Zakat Calculator", "Kalkulator Zakat"],
    dZakat: ["Work out your 2.5% in seconds.", "Kira zakat 2.5% anda dengan pantas."]
  };
  function t(k, n) { var v = T[k] ? T[k][L()] : k; return n != null ? v.replace("{n}", n) : v; }

  var HM = [null,
    ["Muharram", "Muharram", "MUH", "MUH"], ["Safar", "Safar", "SAF", "SAF"],
    ["Rabi al-awwal", "Rabiulawal", "RAB I", "RAW"], ["Rabi al-thani", "Rabiulakhir", "RAB II", "RAK"],
    ["Jumada al-awwal", "Jamadilawal", "JUM I", "JAW"], ["Jumada al-thani", "Jamadilakhir", "JUM II", "JAK"],
    ["Rajab", "Rejab", "RAJ", "REJ"], ["Shaban", "Syaaban", "SHA", "SYA"], ["Ramadan", "Ramadan", "RAM", "RAM"],
    ["Shawwal", "Syawal", "SHAW", "SYW"], ["Dhul-Qadah", "Zulkaedah", "DHUL Q", "ZLK"], ["Dhul-Hijjah", "Zulhijjah", "DHUL H", "ZLH"]];
  // normalised API / legacy spellings -> month number
  var HKEY = {};
  ["muharram"].forEach(function (k) { HKEY[k] = 1; });
  ["safar"].forEach(function (k) { HKEY[k] = 2; });
  ["rabialawwal", "rabiulawwal", "rabialawal", "rabiulawal", "rabiawwal"].forEach(function (k) { HKEY[k] = 3; });
  ["rabialthani", "rabiulthani", "rabialakhir", "rabiulakhir", "rabithani", "rabialakhar"].forEach(function (k) { HKEY[k] = 4; });
  ["jumadaalawwal", "jumadaalula", "jumadaula", "jumadialawwal", "jamadilawal", "jumadaalawal"].forEach(function (k) { HKEY[k] = 5; });
  ["jumadaalthani", "jumadaalakhirah", "jumadaalakhira", "jumadaalakhir", "jumadialthani", "jamadilakhir", "jumadaathani"].forEach(function (k) { HKEY[k] = 6; });
  ["rajab", "rejab"].forEach(function (k) { HKEY[k] = 7; });
  ["shaban", "syaaban", "shaaban"].forEach(function (k) { HKEY[k] = 8; });
  ["ramadan", "ramadhan"].forEach(function (k) { HKEY[k] = 9; });
  ["shawwal", "syawal", "shawal"].forEach(function (k) { HKEY[k] = 10; });
  ["dhulqadah", "dhualqadah", "dhualqidah", "dhulqidah", "dhulqada", "zulkaedah", "dhuulqadah"].forEach(function (k) { HKEY[k] = 11; });
  ["dhulhijjah", "dhualhijjah", "dhulhijja", "zulhijjah", "dhuulhijjah"].forEach(function (k) { HKEY[k] = 12; });
  var ABBR = { MHRM: 1, SAFAR: 2, RAB1: 3, RAB2: 4, JUM1: 5, JUM2: 6, RAJAB: 7, SHAB: 8, RAMA: 9, SHAW: 10, QADA: 11, HIJJ: 12 };
  function normKey(s) { return String(s || "").toLowerCase().replace(/[^a-z]/g, ""); }

  var COMPASS = { N: "Utara", NNE: "Utara Timur Laut", NE: "Timur Laut", ENE: "Timur Timur Laut", E: "Timur", ESE: "Timur Tenggara", SE: "Tenggara", SSE: "Selatan Tenggara", S: "Selatan", SSW: "Selatan Barat Daya", SW: "Barat Daya", WSW: "Barat Barat Daya", W: "Barat", WNW: "Barat Barat Laut", NW: "Barat Laut", NNW: "Utara Barat Laut" };
  var COMPASS_EN = { N: "North", NNE: "North-northeast", NE: "Northeast", ENE: "East-northeast", E: "East", ESE: "East-southeast", SE: "Southeast", SSE: "South-southeast", S: "South", SSW: "South-southwest", SW: "Southwest", WSW: "West-southwest", W: "West", WNW: "West-northwest", NW: "Northwest", NNW: "North-northwest" };
  var ROSE = { cn: ["N", "U"], ce: ["E", "T"], cs: ["S", "S"], cw: ["W", "B"] };
  // prayer-calculation authority labels (the page mixes BM and EN here)
  var AUTH = [
    ["JAKIM (Malaysia)", "JAKIM (Malaysia)"], ["MUIS (Singapore)", "MUIS (Singapura)"], ["Univ. Karachi", "Universiti Karachi"],
    ["Umm al-Qura (Saudi Arabia)", "Umm al-Qura (Arab Saudi)"], ["Dubai (UAE)", "Dubai (UAE)"], ["Kuwait", "Kuwait"], ["Qatar", "Qatar"],
    ["Univ. Tehran", "Universiti Tehran"], ["Egyptian General Authority", "Pihak Berkuasa Am Mesir"], ["Diyanet (Turkey)", "Diyanet (Turki)"],
    ["UOIF (France)", "UOIF (Perancis)"], ["ISNA (North America)", "ISNA (Amerika Utara)"], ["Muslim World League", "Liga Muslim Sedunia"]];
  var AUTH_ALIASES = { "MUIS (Singapura)": 1, "Umm al-Qura (Saudi)": 3, "Egyptian Authority": 8, "Diyanet (Turki)": 9, "UOIF (Perancis)": 10 };
  var GENDER = { "Male": "Lelaki", "Female": "Perempuan", "Unisex": "Lelaki/Perempuan", "male": "Lelaki", "female": "Perempuan", "unisex": "Lelaki/Perempuan" };

  // light-weight language sniffers used only to catch API strings that have no BM translation
  var EN_SW = /\b(the|and|of|to|is|your|you|for|with|from|who|which|when|whoever|upon|me|my|our|we)\b/gi;
  var MS_SW = /\b(dan|yang|untuk|anda|dengan|daripada|kepada|ialah|adalah|tiada|kami|aku|engkau)\b/gi;
  function looksEN(s) { var m = String(s).match(EN_SW); return !!m && m.length >= 2; }

  /* ------------------------------------------------------------------ icons */
  var IC = {
    quran: '<path d="M4 5.5C4 4.7 4.7 4 5.5 4H11v15H5.5A1.5 1.5 0 0 1 4 17.5z"/><path d="M20 5.5c0-.8-.7-1.5-1.5-1.5H13v15h5.5c.8 0 1.5-.7 1.5-1.5z"/><path d="M11 19c0 .6.4 1 1 1s1-.4 1-1"/>',
    hadith: '<path d="M7 3h8l4 4v12.5c0 .8-.7 1.5-1.5 1.5h-10C6.7 21 6 20.3 6 19.5v-15C6 3.7 6.7 3 7.5 3z"/><path d="M14 3v5h5"/><path d="M9.5 12.5h5M9.5 16h5"/>',
    prayer: '<circle cx="12" cy="13" r="8"/><path d="M12 9v4l2.5 2.5"/><path d="M9 2h6"/>',
    qibla: '<circle cx="12" cy="12" r="9"/><path d="m15.5 8.5-2.2 4.8-4.8 2.2 2.2-4.8z"/>',
    verse: '<path d="M12 3l2.4 4.9 5.4.8-3.9 3.8.9 5.4-4.8-2.6-4.8 2.6.9-5.4L4.2 8.7l5.4-.8z"/>',
    dua: '<path d="M8 21c-1.7 0-3-1.3-3-3v-5.5c0-.8.7-1.5 1.5-1.5S8 11.7 8 12.5V15"/><path d="M8 15V6.5C8 5.7 8.7 5 9.5 5s1.5.7 1.5 1.5V12"/><path d="M16 21c1.7 0 3-1.3 3-3v-5.5c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5V15"/><path d="M16 15V6.5c0-.8-.7-1.5-1.5-1.5S13 5.7 13 6.5V12"/>',
    n99: '<path d="M12 2.5l2.2 4 4.5.6-2.6 3.6 1.6 4.3-4.2-1.7-1.5 4.4-1.5-4.4-4.2 1.7 1.6-4.3L5.3 7.1l4.5-.6z"/><path d="M7 21h10"/>',
    names: '<path d="M20 12.5 12.5 20a2 2 0 0 1-2.8 0L4 14.3V4h10.3L20 9.7a2 2 0 0 1 0 2.8z"/><circle cx="8.5" cy="8.5" r="1.5"/>',
    cal: '<rect x="3.5" y="5" width="17" height="15.5" rx="2.5"/><path d="M3.5 10h17M8 3v4M16 3v4"/>',
    events: '<path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11z"/>',
    ram: '<path d="M6 21V11l6-5 6 5v10"/><path d="M4 21h16"/><path d="M12 6V3"/><path d="M10 21v-4a2 2 0 0 1 4 0v4"/>',
    zakat: '<rect x="3" y="6" width="18" height="13" rx="2.5"/><path d="M3 10.5h18"/><circle cx="16" cy="15" r="1.4"/>',
    arrow: '<path d="M7 17 17 7M8 7h9v9"/>',
    down: '<path d="M12 5v14M6 13l6 6 6-6"/>',
    moon: '<path d="M20.5 14.5A8.5 8.5 0 1 1 9.5 3.5a7 7 0 0 0 11 11z"/>',
    clock: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/>',
    up: '<path d="M12 19V5M6 11l6-6 6 6"/>',
    pin: '<path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9l-5.2 2.7 1-5.8-4.3-4.1 5.9-.9z"/>',
    flame: '<path d="M12 21c3.9 0 6.5-2.6 6.5-6.2 0-3.4-2.4-5.6-3.6-8.3-.4 2-1.6 3.3-2.9 3.9.2-2.8-1-5.4-3.4-6.9.3 3-1.8 5.1-3 7-.9 1.4-1.1 2.6-1.1 4.3C4.5 18.4 8.1 21 12 21z"/>',
    play: '<path d="M8 5.5 19 12 8 18.5z"/>',
    share: '<circle cx="18" cy="5.5" r="2.5"/><circle cx="6" cy="12" r="2.5"/><circle cx="18" cy="18.5" r="2.5"/><path d="m8.2 10.8 7.6-4.1M8.2 13.2l7.6 4.1"/>',
    pinmap: '<path d="M12 21s-6.5-5.6-6.5-11A6.5 6.5 0 0 1 18.5 10c0 5.4-6.5 11-6.5 11z"/><circle cx="12" cy="10" r="2.3"/>'
  };
  function svg(name, cls) { return '<svg class="' + (cls || "dxu-ico") + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + IC[name] + "</svg>"; }

  /* ------------------------------------------------------------------ hijri helpers */
  function hijriOf(d) { return typeof window.duCalHijri === "function" ? window.duCalHijri(d) : null; }
  function daysToRamadan() {
    var now = new Date(), h = hijriOf(now);
    if (h && h.month === 9) return { inRam: true, day: h.day };
    if (typeof window.duNextRamadan !== "function") return null;
    var nr = window.duNextRamadan(now); if (!nr) return null;
    return { inRam: false, days: Math.round((nr - now) / 86400000) };
  }

  /* ------------------------------------------------------------------ hero */
  var hero = du.querySelector(".du-hero");
  var langBox = du.querySelector(".du-lang");
  var bEn = $("duLangEn"), bBm = $("duLangBm");
  if (hero) {
    hero.classList.add("dxu-hero");
    hero.setAttribute("aria-labelledby", "dxuTitle");
    var eyebrow = hero.querySelector(".du-ey"), lead = hero.querySelector(".lead"), btns = hero.querySelector(".du-herobtns"), h1 = hero.querySelector("h1");
    if (h1) { h1.id = "dxuTitle"; h1.className = "dxu-title"; }
    var top = el("div", "dxu-top");
    if (langBox && bEn && bBm) {
      langBox.className = "du-lang dxu-lang";
      langBox.setAttribute("role", "group");
      langBox.appendChild(bBm); langBox.appendChild(bEn); // BM first, like Digital Quran
      [bBm, bEn].forEach(function (b) { b.type = "button"; });
      top.appendChild(langBox);
    }
    var grid = el("div", "dxu-hero-grid");
    var text = el("div", "dxu-hero-text");
    if (eyebrow) text.appendChild(eyebrow);
    if (h1) text.appendChild(h1);
    if (lead) text.appendChild(lead);
    var live = el("div", "dxu-live");
    live.id = "dxuLive";
    text.appendChild(live);
    if (btns) {
      text.appendChild(btns);
      btns.querySelectorAll("a.du-btn").forEach(function (a, i) {
        a.insertAdjacentHTML(i === 0 ? "afterbegin" : "afterbegin", svg(i === 0 ? "quran" : "hadith"));
      });
    }
    var ar = el("p", "dxu-ar", 'الأمة الرقمية<small>أُمَّةً وَاحِدَةً</small>');
    ar.setAttribute("lang", "ar"); ar.setAttribute("dir", "rtl"); ar.setAttribute("aria-hidden", "true");
    grid.appendChild(text); grid.appendChild(ar);
    hero.innerHTML = "";
    hero.appendChild(el("div", "dxu-glow")); hero.appendChild(top); hero.appendChild(grid);
  }

  /* ------------------------------------------------------------------ bento + tool search + pins */
  var TILES = [
    { k: "Quran", ic: "quran", href: "/pages/digital-quran", big: true, ar: "القرآن", kw: "quran al-quran surah ayat mushaf tafsir reciter qari audio" },
    { k: "Hadith", ic: "hadith", href: "/pages/digital-hadith", big: true, ar: "الحديث", kw: "hadith hadis bukhari muslim sunnah" },
    { k: "Prayer", ic: "prayer", jump: "sec-prayer", live: "prayer", kw: "prayer solat salah waktu times azan subuh zohor asar maghrib isyak fajr dhuhr asr isha" },
    { k: "Qibla", ic: "qibla", jump: "sec-prayer", kw: "qibla kiblat kaabah kaaba compass kompas arah direction" },
    { k: "Verse", ic: "verse", jump: "sec-verse", kw: "verse ayat ayah day hari" },
    { k: "Dua", ic: "dua", jump: "sec-dua", kw: "dua doa zikir dhikr morning evening pagi petang" },
    { k: "99", ic: "n99", jump: "sec-99", kw: "99 names asma husna allah nama" },
    { k: "Names", ic: "names", jump: "sec-names", kw: "baby names nama muslim anak boy girl lelaki perempuan" },
    { k: "Cal", ic: "cal", jump: "sec-calendar", kw: "calendar kalendar hijri hijrah date tarikh" },
    { k: "Events", ic: "events", jump: "sec-events", kw: "events peristiwa eid raya aidilfitri aidiladha maulid israk ashura" },
    { k: "Ram", ic: "ram", jump: "sec-ramadan", live: "ram", kw: "ramadan puasa fasting countdown iftar sahur suhoor" },
    { k: "Zakat", ic: "zakat", jump: "sec-zakat", kw: "zakat calculator kalkulator nisab gold emas silver perak" }
  ];
  var PINK = "dxu-pins";
  function getPins() { try { var p = JSON.parse(localStorage.getItem(PINK) || "[]"); return Array.isArray(p) ? p : []; } catch (e) { return []; } }
  function savePins(p) { try { localStorage.setItem(PINK, JSON.stringify(p)); } catch (e) {} }
  var bento = el("section", "dxu-explore");
  bento.setAttribute("aria-labelledby", "dxuExploreH");
  var bh = '<div class="dxu-sechead dxu-rv"><div><h2 id="dxuExploreH" data-dxu="explore"></h2><p data-dxu="exploreSub"></p></div>' +
    '<label class="dxu-find"><span class="dxu-vh" data-dxu="findLbl"></span>' + '<svg class="dxu-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>' +
    '<input id="dxuFind" type="search" autocomplete="off" enterkeyhint="go" data-dxu-ph="findPh"><button type="button" class="dxu-find-x" id="dxuFindX" hidden><span class="dxu-vh" data-dxu="clear"></span>&times;</button></label></div>' +
    '<div id="dxuCont"></div><div class="dxu-bento" id="dxuBento">';
  TILES.forEach(function (x, i) {
    var href = x.href || ("#" + x.jump);
    bh += '<div class="dxu-tile' + (x.big ? " dxu-tile--big" : "") + ' dxu-rv" data-k="' + x.k + '" data-kw="' + x.kw + '" style="--i:' + i + '">' +
      '<a class="dxu-tlink" href="' + href + '"' + (x.jump ? ' data-jump="' + x.jump + '"' : "") + ">" +
      '<span class="dxu-tico">' + svg(x.ic) + "</span>" +
      '<span class="dxu-tbody"><span class="dxu-ttitle" data-dxu="t' + x.k + '"></span><span class="dxu-tdesc" data-dxu="d' + x.k + '"></span>' +
      (x.live ? '<span class="dxu-tlive" data-live="' + x.live + '" hidden></span>' : "") + "</span>" +
      (x.ar ? '<span class="dxu-tar" lang="ar" dir="rtl" aria-hidden="true">' + x.ar + "</span>" : "") +
      '<span class="dxu-tgo">' + svg(x.href ? "arrow" : "down") + "</span></a>" +
      '<button type="button" class="dxu-pin" aria-pressed="false">' + svg("pin") + "</button></div>";
  });
  bh += '</div><p class="dxu-empty" id="dxuEmpty" hidden data-dxu="noTools"></p>';
  bento.innerHTML = bh;
  var bentoGrid = bento.querySelector("#dxuBento");
  function orderTiles() {
    var pins = getPins();
    var tiles = Array.prototype.slice.call(bentoGrid.children);
    tiles.sort(function (a, b) {
      var pa = pins.indexOf(a.getAttribute("data-k")), pb = pins.indexOf(b.getAttribute("data-k"));
      var oa = TILES.findIndex(function (x) { return x.k === a.getAttribute("data-k"); }), ob = TILES.findIndex(function (x) { return x.k === b.getAttribute("data-k"); });
      var ba = a.classList.contains("dxu-tile--big") ? 0 : 1, bb = b.classList.contains("dxu-tile--big") ? 0 : 1;
      if (ba !== bb) return ba - bb; // the two page cards always lead the grid
      if (pa >= 0 && pb >= 0) return pa - pb; if (pa >= 0) return -1; if (pb >= 0) return 1; return oa - ob;
    });
    tiles.forEach(function (tile) {
      var on = pins.indexOf(tile.getAttribute("data-k")) >= 0;
      tile.classList.toggle("dxu-pinned", on);
      var pb = tile.querySelector(".dxu-pin"); pb.setAttribute("aria-pressed", on ? "true" : "false");
      bentoGrid.appendChild(tile);
    });
  }
  function labelPins() {
    bentoGrid.querySelectorAll(".dxu-tile").forEach(function (tile) {
      var pb = tile.querySelector(".dxu-pin"), tt = tile.querySelector(".dxu-ttitle").textContent;
      var on = pb.getAttribute("aria-pressed") === "true";
      pb.setAttribute("aria-label", (on ? t("unpin") : t("pin")) + ": " + tt);
      pb.title = on ? t("unpin") : t("pin");
    });
  }
  bentoGrid.addEventListener("click", function (e) {
    var pb = e.target.closest(".dxu-pin"); if (!pb) return;
    e.preventDefault();
    var k = pb.closest(".dxu-tile").getAttribute("data-k"), pins = getPins(), i = pins.indexOf(k);
    if (i >= 0) pins.splice(i, 1); else pins.unshift(k);
    savePins(pins);
    flip(function () { orderTiles(); });
    labelPins();
    toast(i >= 0 ? t("unpinned") : t("pinned"));
  });
  // FLIP animation for re-ordering
  function flip(mutate) {
    var tiles = Array.prototype.slice.call(bentoGrid.children), first = new Map();
    if (!RM) tiles.forEach(function (n) { first.set(n, n.getBoundingClientRect()); });
    mutate();
    if (RM) return;
    tiles.forEach(function (n) {
      var f = first.get(n), l2 = n.getBoundingClientRect(); if (!f) return;
      var dx = f.left - l2.left, dy = f.top - l2.top; if (!dx && !dy) return;
      n.animate([{ transform: "translate(" + dx + "px," + dy + "px)" }, { transform: "none" }], { duration: 360, easing: "cubic-bezier(.2,.8,.2,1)" });
    });
  }
  var findIn = bento.querySelector("#dxuFind"), findX = bento.querySelector("#dxuFindX"), emptyP = bento.querySelector("#dxuEmpty");
  function fold(s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, ""); }
  function filterTiles() {
    var q = fold(findIn.value).trim(), shown = 0;
    bentoGrid.querySelectorAll(".dxu-tile").forEach(function (tile) {
      var x = TILES.filter(function (z) { return z.k === tile.getAttribute("data-k"); })[0];
      var hay = fold(x.kw + " " + T["t" + x.k].join(" ") + " " + T["d" + x.k].join(" "));
      var ok = !q || q.split(/\s+/).every(function (w) { return hay.indexOf(w) >= 0; });
      tile.hidden = !ok; if (ok) shown++;
    });
    emptyP.hidden = shown > 0; findX.hidden = !q;
    bentoGrid.classList.toggle("dxu-filtered", !!q);
  }
  findIn.addEventListener("input", filterTiles);
  findIn.addEventListener("keydown", function (e) {
    if (e.key === "Enter") { var first = bentoGrid.querySelector(".dxu-tile:not([hidden]) .dxu-tlink"); if (first) { e.preventDefault(); first.click(); } }
    if (e.key === "Escape") { findIn.value = ""; filterTiles(); }
  });
  findX.addEventListener("click", function () { findIn.value = ""; filterTiles(); findIn.focus(); });

  /* ------------------------------------------------------------------ continue where you left off (Digital Quran player) */
  var SURAH = ["Al-Fatihah", "Al-Baqarah", "Ali 'Imran", "An-Nisa'", "Al-Ma'idah", "Al-An'am", "Al-A'raf", "Al-Anfal", "At-Taubah", "Yunus", "Hud", "Yusuf", "Ar-Ra'd", "Ibrahim", "Al-Hijr", "An-Nahl", "Al-Isra'", "Al-Kahf", "Maryam", "Ta-Ha", "Al-Anbiya'", "Al-Hajj", "Al-Mu'minun", "An-Nur", "Al-Furqan", "Ash-Shu'ara'", "An-Naml", "Al-Qasas", "Al-'Ankabut", "Ar-Rum", "Luqman", "As-Sajdah", "Al-Ahzab", "Saba'", "Fatir", "Ya-Sin", "As-Saffat", "Sad", "Az-Zumar", "Ghafir", "Fussilat", "Ash-Shura", "Az-Zukhruf", "Ad-Dukhan", "Al-Jathiyah", "Al-Ahqaf", "Muhammad", "Al-Fath", "Al-Hujurat", "Qaf", "Adh-Dhariyat", "At-Tur", "An-Najm", "Al-Qamar", "Ar-Rahman", "Al-Waqi'ah", "Al-Hadid", "Al-Mujadilah", "Al-Hashr", "Al-Mumtahanah", "As-Saff", "Al-Jumu'ah", "Al-Munafiqun", "At-Taghabun", "At-Talaq", "At-Tahrim", "Al-Mulk", "Al-Qalam", "Al-Haqqah", "Al-Ma'arij", "Nuh", "Al-Jinn", "Al-Muzzammil", "Al-Muddaththir", "Al-Qiyamah", "Al-Insan", "Al-Mursalat", "An-Naba'", "An-Nazi'at", "'Abasa", "At-Takwir", "Al-Infitar", "Al-Mutaffifin", "Al-Inshiqaq", "Al-Buruj", "At-Tariq", "Al-A'la", "Al-Ghashiyah", "Al-Fajr", "Al-Balad", "Ash-Shams", "Al-Lail", "Ad-Duha", "Ash-Sharh", "At-Tin", "Al-'Alaq", "Al-Qadr", "Al-Baiyinah", "Az-Zalzalah", "Al-'Adiyat", "Al-Qari'ah", "At-Takathur", "Al-'Asr", "Al-Humazah", "Al-Fil", "Quraish", "Al-Ma'un", "Al-Kauthar", "Al-Kafirun", "An-Nasr", "Al-Masad", "Al-Ikhlas", "Al-Falaq", "An-Nas"];
  function fmtT(sec) { sec = Math.max(0, Math.floor(sec)); var h = Math.floor(sec / 3600), m = Math.floor(sec % 3600 / 60), s2 = sec % 60; return (h ? h + ":" + (m < 10 ? "0" : "") : "") + m + ":" + (s2 < 10 ? "0" : "") + s2; }
  function renderCont() {
    var box = $("dxuCont"); if (!box) return;
    var sv = null, st = null;
    try { sv = JSON.parse(localStorage.getItem("quran-player-v1")); } catch (e) {}
    try { st = JSON.parse(localStorage.getItem("quran-streak-v1") || "null"); } catch (e) {}
    if (!sv || typeof sv.i !== "number" || !SURAH[sv.i] || !(sv.t > 5)) { box.innerHTML = ""; box.hidden = true; return; }
    var streak = st && st.n >= 2 ? '<span class="dxu-streak">' + svg("flame") + esc(t("streak", st.n)) + "</span>" : "";
    box.hidden = false;
    box.innerHTML = '<a class="dxu-cont dxu-rv dxu-in" href="/pages/digital-quran#surah-' + (sv.i + 1) + '">' +
      '<span class="dxu-cont-ic">' + svg("play") + "</span>" +
      '<span class="dxu-cont-b"><span class="dxu-cont-l">' + esc(t("contLbl")) + "</span>" +
      '<span class="dxu-cont-t">Surah ' + esc(SURAH[sv.i]) + ' <span class="dxu-cont-m">· ' + esc(fmtT(sv.t)) + "</span></span>" + streak + "</span>" +
      '<span class="dxu-tgo">' + svg("arrow") + "</span></a>";
  }

  var nav = $("duNav");
  if (nav) {
    nav.parentNode.insertBefore(bento, nav);
    nav.classList.add("dxu-nav");
    nav.setAttribute("role", "navigation");
  } else if (hero) hero.parentNode.insertBefore(bento, hero.nextSibling);
  orderTiles();
  renderCont();

  /* ------------------------------------------------------------------ section tidy */
  // Quran + Hadith feature cards side by side
  var fq = $("sec-quran"), fh = $("sec-hadith");
  if (fq && fh && fq.parentNode === fh.parentNode) {
    var fg = el("div", "dxu-feat-grid");
    fq.parentNode.insertBefore(fg, fq);
    fg.appendChild(fq); fg.appendChild(fh);
    [[fq, "quran"], [fh, "hadith"]].forEach(function (p) {
      var ic = p[0].querySelector(".fic"); if (ic) { ic.innerHTML = svg(p[1]); ic.setAttribute("aria-hidden", "true"); }
      var a = p[0].querySelector("a.du-btn"); if (a) a.insertAdjacentHTML("beforeend", svg("arrow"));
    });
  }
  // emoji icons -> line icons
  du.querySelectorAll(".du-w .du-ic").forEach(function (s, i) { s.innerHTML = svg(i === 0 ? "prayer" : "qibla"); s.setAttribute("aria-hidden", "true"); });
  // the dot in section headings is decorative
  du.querySelectorAll(".du-h .dot").forEach(function (d) { d.setAttribute("aria-hidden", "true"); });
  // section headings become real headings for assistive tech
  du.querySelectorAll(".du-h").forEach(function (h) { h.setAttribute("role", "heading"); h.setAttribute("aria-level", "2"); });
  var topBtn = $("duTop"); if (topBtn) { topBtn.innerHTML = svg("up"); topBtn.type = "button"; }
  var s99 = $("du99Search"); if (s99) { s99.type = "search"; s99.setAttribute("autocomplete", "off"); }
  du.querySelectorAll(".du-toggle").forEach(function (g) { g.setAttribute("role", "group"); });
  du.querySelectorAll(".du-toggle button,.du-locbtn,.du-navchip,.du-btn:not(a)").forEach(function (b) { if (!b.getAttribute("type")) b.type = "button"; });
  // reveal targets
  du.querySelectorAll(".du-sec,.du-h,.du-hsub,.du-group,.dxu-sechead").forEach(function (n) { n.classList.add("dxu-rv"); });
  // widen the theme's narrow page container
  var pw = du.closest(".page-width"); if (pw) pw.classList.add("dxu-wide");

  /* ------------------------------------------------------------------ toast + share */
  var toastEl = el("div", "dxu-toast"); toastEl.setAttribute("role", "status"); toastEl.setAttribute("aria-live", "polite");
  du.appendChild(toastEl);
  var toastT = 0;
  function toast(msg) {
    toastEl.textContent = msg; toastEl.classList.add("dxu-show");
    clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove("dxu-show"); }, 2200);
  }
  function copyText(txt) {
    if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(txt);
    return new Promise(function (res, rej) {
      try { var ta = el("textarea"); ta.value = txt; ta.setAttribute("readonly", ""); ta.style.cssText = "position:fixed;top:-1000px;opacity:0"; document.body.appendChild(ta); ta.select(); var ok = document.execCommand("copy"); ta.remove(); ok ? res() : rej(); } catch (e) { rej(e); }
    });
  }
  function share(data, copiedMsg) {
    if (navigator.share) {
      return navigator.share(data).catch(function (e) { if (e && e.name === "AbortError") return; return copyText((data.text ? data.text + "\n" : "") + data.url).then(function () { toast(copiedMsg); }); });
    }
    return copyText((data.text && data.text !== t("shareText") ? data.text + "\n" : "") + data.url).then(function () { toast(copiedMsg); }, function () { toast(t("shareFail")); });
  }
  var pageUrl = location.origin + location.pathname;
  if (hero) {
    var topRow = hero.querySelector(".dxu-top");
    var sb = el("button", "dxu-iconbtn dxu-share", svg("share") + '<span data-dxu="share"></span>');
    sb.type = "button"; sb.id = "dxuShare";
    sb.addEventListener("click", function () { share({ title: "Digital Ummah", text: t("shareText"), url: pageUrl }, t("copied")); });
    if (topRow) topRow.appendChild(sb);
  }
  function addVerseShare() {
    var vb = du.querySelector("#duVerse .vbtns");
    if (!vb || vb.querySelector(".dxu-vshare")) return;
    var b = el("button", "du-locbtn dxu-ghost dxu-vshare", svg("share") + "<span>" + esc(t("shareVerse")) + "</span>");
    b.type = "button";
    b.addEventListener("click", function () {
      var box = $("duVerse"), q = function (c) { var n = box.querySelector(c); return n ? n.textContent.trim() : ""; };
      var txt = q(".ar") + "\n\n" + q(".en") + "\n— " + q(".vk");
      share({ title: q(".vk"), text: txt, url: pageUrl + "#sec-verse" }, t("copiedVerse"));
    });
    vb.appendChild(b);
  }

  /* ------------------------------------------------------------------ prayer times for a chosen city */
  var CITIES = [
    ["kl", "Kuala Lumpur", 3.139, 101.687], ["pjy", "Putrajaya", 2.926, 101.696], ["sa", "Shah Alam (Selangor)", 3.073, 101.518],
    ["jb", "Johor Bahru (Johor)", 1.492, 103.741], ["mlk", "Melaka", 2.189, 102.250], ["srb", "Seremban (Negeri Sembilan)", 2.726, 101.938],
    ["ktn", "Kuantan (Pahang)", 3.817, 103.326], ["kt", "Kuala Terengganu (Terengganu)", 5.330, 103.137], ["kb", "Kota Bharu (Kelantan)", 6.125, 102.238],
    ["as", "Alor Setar (Kedah)", 6.121, 100.367], ["kgr", "Kangar (Perlis)", 6.441, 100.198], ["gt", "George Town (Pulau Pinang)", 5.414, 100.329],
    ["ipo", "Ipoh (Perak)", 4.597, 101.090], ["kk", "Kota Kinabalu (Sabah)", 5.980, 116.073], ["kch", "Kuching (Sarawak)", 1.553, 110.359],
    ["lbn", "Labuan", 5.280, 115.242], ["sg", ["Singapore", "Singapura"], 1.352, 103.820]
  ];
  function cityName(c) { return Array.isArray(c[1]) ? c[1][L()] : c[1]; }
  function cityById(id) { return CITIES.filter(function (c) { return c[0] === id; })[0] || null; }
  function getZone() { try { var z = localStorage.getItem("dxu-zone"); var c = cityById(z); if (!c) return null; var co = JSON.parse(localStorage.getItem("du_coords") || "null"); return co && Math.abs(co.lat - c[2]) < 1e-6 && Math.abs(co.lng - c[3]) < 1e-6 ? c : null; } catch (e) { return null; } }
  var citySel = null;
  var pBtn = du.querySelector('#duPrayerOut') && du.querySelector('#duPrayerOut').parentNode.querySelector(".du-locbtn");
  if (pBtn) {
    var row = el("div", "dxu-prow");
    pBtn.parentNode.insertBefore(row, pBtn);
    row.appendChild(pBtn);
    row.insertAdjacentHTML("beforeend", '<span class="dxu-or" data-dxu="orCity"></span><label class="dxu-select">' + svg("pinmap") + '<span class="dxu-vh" data-dxu="cityLbl"></span><select id="dxuCity"></select></label>');
    citySel = row.querySelector("#dxuCity");
    citySel.addEventListener("change", function () {
      var c = cityById(citySel.value); if (!c) return;
      try { localStorage.setItem("dxu-zone", c[0]); localStorage.setItem("du_coords", JSON.stringify({ lat: c[2], lng: c[3] })); } catch (e) {}
      if (typeof window.duRenderPrayer === "function") window.duRenderPrayer(c[2], c[3]);
      if (typeof window.duLoadRamadan === "function") window.duLoadRamadan();
    });
  }
  function renderCityOptions() {
    if (!citySel) return;
    var z = getZone(), h = '<option value="">' + esc(t("cityPh")) + "</option>";
    CITIES.forEach(function (c) { h += '<option value="' + c[0] + '"' + (z && z[0] === c[0] ? " selected" : "") + ">" + esc(cityName(c)) + "</option>"; });
    citySel.innerHTML = h;
    citySel.setAttribute("aria-label", t("cityLbl"));
  }
  // the chosen city uses its own official authority, wherever the visitor's device clock is
  var origMethod = window.duMethod;
  if (typeof origMethod === "function") window.duMethod = function (tz) {
    var z = getZone();
    if (z) return z[0] === "sg" ? ["Singapore", "MUIS (Singapura)"] : ["JAKIM", "JAKIM (Malaysia)"];
    return origMethod(tz);
  };
  var origGetPrayer = window.duGetPrayer;
  if (typeof origGetPrayer === "function") window.duGetPrayer = function () {
    try { localStorage.removeItem("dxu-zone"); } catch (e) {}
    if (citySel) citySel.value = "";
    return origGetPrayer.apply(this, arguments);
  };

  /* ------------------------------------------------------------------ pointer glow / tilt on tool cards */
  var fine = false; try { fine = window.matchMedia("(hover: hover) and (pointer: fine)").matches; } catch (e) {}
  if (fine) {
    du.addEventListener("pointermove", function (e) {
      var c = e.target.closest && e.target.closest(".dxu-tile,.du-feature,.dxu-cont");
      if (!c) return;
      var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
      c.style.setProperty("--mx", (x * 100).toFixed(1) + "%"); c.style.setProperty("--my", (y * 100).toFixed(1) + "%");
      if (!RM && c.classList.contains("dxu-tile")) { c.style.setProperty("--ry", ((x - .5) * 5).toFixed(2) + "deg"); c.style.setProperty("--rx", ((.5 - y) * 5).toFixed(2) + "deg"); }
    }, { passive: true });
    du.addEventListener("pointerout", function (e) {
      var c = e.target.closest && e.target.closest(".dxu-tile");
      if (c && !c.contains(e.relatedTarget)) { c.style.removeProperty("--rx"); c.style.removeProperty("--ry"); }
    });
  }

  /* ------------------------------------------------------------------ static strings */
  function applyStatic() {
    var l = L();
    du.setAttribute("lang", l ? "ms" : "en");
    du.querySelectorAll("[data-dxu]").forEach(function (n) { n.textContent = t(n.getAttribute("data-dxu")); });
    if (langBox) langBox.setAttribute("aria-label", t("langGroup"));
    if (bBm) { bBm.setAttribute("aria-pressed", l ? "true" : "false"); bBm.setAttribute("lang", "ms"); bBm.setAttribute("aria-label", "Bahasa Melayu"); }
    if (bEn) { bEn.setAttribute("aria-pressed", l ? "false" : "true"); bEn.setAttribute("lang", "en"); bEn.setAttribute("aria-label", "English"); }
    if (nav) nav.setAttribute("aria-label", t("jump"));
    if (topBtn) topBtn.setAttribute("aria-label", t("toTop"));
    if (s99) s99.setAttribute("aria-label", s99.getAttribute("placeholder") || "");
    du.querySelectorAll("[data-dxu-ph]").forEach(function (n) { n.setAttribute("placeholder", t(n.getAttribute("data-dxu-ph"))); });
    du.querySelectorAll("[data-dxu-al]").forEach(function (n) { n.setAttribute("aria-label", t(n.getAttribute("data-dxu-al"))); n.title = t(n.getAttribute("data-dxu-al")); });
    if (findIn) findIn.setAttribute("aria-label", t("findLbl"));
    labelPins();
    renderLive(); renderCont(); renderCityOptions();
  }

  /* ------------------------------------------------------------------ live chips */
  function hijriLabel() {
    var h = hijriOf(new Date()); if (!h || !HM[h.month]) return "";
    return h.day + " " + HM[h.month][L()] + " " + h.year + (L() ? " H" : " AH");
  }
  function renderLive() {
    var box = $("dxuLive"); if (!box) return;
    var html = "";
    var hl = hijriLabel();
    if (hl) html += '<span class="dxu-chip">' + svg("moon") + "<span>" + esc(hl) + "</span></span>";
    var r = daysToRamadan();
    if (r) html += '<a class="dxu-chip dxu-chip--link" href="#sec-ramadan" data-jump="sec-ramadan">' + svg("ram") + "<span>" + esc(r.inRam ? t("ramDay", r.day) : t("ramIn", r.days)) + "</span></a>";
    html += '<a class="dxu-chip dxu-chip--link dxu-chip--prayer" href="#sec-prayer" data-jump="sec-prayer" hidden>' + svg("clock") + '<span class="dxu-np"></span></a>';
    box.innerHTML = html;
    var rl = bento.querySelector('[data-live="ram"]');
    if (rl && r) { rl.textContent = r.inRam ? t("ramDay", r.day) : t("ramIn", r.days); rl.hidden = false; }
    tickPrayer();
  }
  function tickPrayer() {
    var cd = $("duCountdown"), lb = $("duNextLbl");
    var chip = du.querySelector(".dxu-chip--prayer"), tl = bento.querySelector('[data-live="prayer"]');
    var ok = cd && lb && /\d/.test(cd.textContent) && cd.textContent.indexOf("--") < 0 && lb.textContent && lb.textContent !== "-";
    var txt = ok ? lb.textContent + " · " + cd.textContent : "";
    if (chip) { chip.hidden = !ok; var s = chip.querySelector(".dxu-np"); if (s && ok) s.textContent = txt; if (ok) chip.setAttribute("aria-label", t("nextPr") + ": " + txt); }
    if (tl) { tl.hidden = !ok; if (ok) tl.textContent = txt; }
  }
  setInterval(tickPrayer, 1000);

  /* ------------------------------------------------------------------ dynamic-content language fixes */
  var fixing = false;
  function fixDynamic() {
    if (fixing) return; fixing = true;
    try {
      var l = L();
      // Today: Hijri month name comes from the API in English
      du.querySelectorAll(".du-today .mon").forEach(function (m) {
        var raw = m.getAttribute("data-dxu-raw") || m.textContent;
        var mm = raw.match(/^(.*?)\s+(\d{3,4})\s*(AH|H)?\s*$/);
        if (!mm) return;
        var num = HKEY[normKey(mm[1])];
        if (!num) { var h = hijriOf(new Date()); num = h && h.month; }
        if (!num || !HM[num]) return;
        m.setAttribute("data-dxu-raw", raw);
        var out = HM[num][l] + " " + mm[2] + (l ? " H" : " AH");
        if (m.textContent !== out) m.textContent = out;
      });
      // Events: month abbreviations
      du.querySelectorAll(".du-ev .cal .mo").forEach(function (m) {
        var raw = m.getAttribute("data-dxu-raw") || m.textContent.trim();
        var num = ABBR[raw]; if (!num) return;
        m.setAttribute("data-dxu-raw", raw);
        var out = HM[num][l ? 3 : 2]; if (m.textContent !== out) m.textContent = out;
        var cell = m.closest(".cal"); if (cell) cell.setAttribute("aria-hidden", "true");
      });
      // Events without a BM translation (new API entries) — hide English-only description in BM
      if (l) du.querySelectorAll(".du-ev .ed").forEach(function (d) { if (looksEN(d.textContent)) { var p = d.textContent.split(" · "); d.textContent = p[p.length - 1]; } });
      // Calendar arrows
      var cb = du.querySelectorAll(".du-cal-nav button");
      if (cb.length === 2) { cb[0].setAttribute("aria-label", t("prevMonth")); cb[1].setAttribute("aria-label", t("nextMonth")); cb[0].type = cb[1].type = "button"; }
      // Qibla compass letters + bearing words
      Object.keys(ROSE).forEach(function (c) { du.querySelectorAll(".du-rose ." + c).forEach(function (s) { var v = ROSE[c][l]; if (s.textContent !== v) s.textContent = v; s.setAttribute("aria-hidden", "true"); }); });
      du.querySelectorAll(".du-bearing small").forEach(function (s) {
        var raw = s.getAttribute("data-dxu-raw") || s.textContent.trim();
        if (!COMPASS[raw]) return;
        s.setAttribute("data-dxu-raw", raw);
        var out = l ? COMPASS[raw] : COMPASS_EN[raw]; if (s.textContent !== out) s.textContent = out;
      });
      // Prayer authority label
      du.querySelectorAll("#duPrayerOut .du-place b").forEach(function (b) {
        var v = b.textContent, idx = -1;
        for (var i = 0; i < AUTH.length; i++) if (AUTH[i][0] === v || AUTH[i][1] === v) { idx = i; break; }
        if (idx < 0 && AUTH_ALIASES[v] != null) idx = AUTH_ALIASES[v];
        if (idx >= 0 && v !== AUTH[idx][l]) b.textContent = AUTH[idx][l];
      });
      // Chosen city: show its name instead of the time-zone city
      var zc = getZone();
      if (zc) du.querySelectorAll("#duPrayerOut .du-place").forEach(function (p) {
        var b = p.querySelector("b"); if (b && b.textContent.indexOf(cityName(zc)) !== 0) b.textContent = cityName(zc);
      });
      addVerseShare();
      // Prayer list: "Zohor - Seterusnya" -> pill
      du.querySelectorAll("#duPrayerOut .du-row.next .p2").forEach(function (p) {
        var parts = p.textContent.split(" - ");
        if (parts.length === 2) p.innerHTML = esc(parts[0]) + ' <span class="dxu-nextpill">' + esc(parts[1]) + "</span>";
      });
      // Duas: English fallback text in BM mode
      if (l) du.querySelectorAll("#duDuaList .du-dua").forEach(function (d) {
        var tr = d.querySelector(".dtr");
        if (tr && !tr.getAttribute("data-dxu-chk")) {
          tr.setAttribute("data-dxu-chk", "1");
          if (looksEN(tr.textContent)) { tr.textContent = t("noTrans"); tr.classList.add("dxu-muted"); }
        }
        var dt = d.querySelector(".dt");
        if (dt && dt.firstChild && dt.firstChild.nodeType === 3 && looksEN(dt.firstChild.nodeValue)) dt.firstChild.nodeValue = "";
      });
      // Dua source label lives in a single text node: keep it, it is a reference (e.g. "Sahih Muslim")
      // 99 Names: in BM the name and meaning are identical — don't show the duplicate
      du.querySelectorAll(".du-n99 .c").forEach(function (c) {
        var e = c.querySelector(".e"), m = c.querySelector(".m");
        if (e && m) c.classList.toggle("dxu-same", e.textContent.trim() === m.textContent.trim());
        if (!c.hasAttribute("tabindex")) { c.setAttribute("tabindex", "0"); c.setAttribute("role", "button"); }
        c.setAttribute("aria-expanded", c.classList.contains("on") ? "true" : "false");
      });
      // Muslim names: gender words from API
      if (l) du.querySelectorAll(".du-name .nmeta").forEach(function (n) {
        var v = n.textContent; Object.keys(GENDER).forEach(function (g) { v = v.replace(new RegExp("\\b" + g + "\\b"), GENDER[g]); });
        if (v !== n.textContent) n.textContent = v;
      });
      // Zakat: API error messages are English; amounts formatted for locale
      du.querySelectorAll("#duZakatOut .du-err").forEach(function (e) { if (l && looksEN(e.textContent + " the of")) e.textContent = window.duTxt ? window.duTxt("failed") : e.textContent; });
      du.querySelectorAll("#duZakatOut .rv").forEach(function (v) {
        var n = parseFloat(String(v.textContent).replace(/[^0-9.\-]/g, ""));
        if (!isNaN(n)) { var f = n.toLocaleString(l ? "ms-MY" : "en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 }); if (v.textContent !== f) v.textContent = f; }
      });
      // 99 Names: the page shows a bare "-" (styled as a loader) when the search has no match
      du.querySelectorAll("#duNames99 > .du-loading").forEach(function (n) {
        if (n.textContent.trim() === "-") { n.className = "dxu-nores"; n.textContent = t("no99"); n.setAttribute("role", "status"); }
      });
      // generic: loaders/errors get live-region semantics
      du.querySelectorAll(".du-loading,.du-err").forEach(function (n) { if (!n.getAttribute("role")) n.setAttribute("role", n.classList.contains("du-err") ? "alert" : "status"); });
    } catch (e) { /* never break the page */ }
    fixing = false;
  }
  var pending = false;
  var mo = new MutationObserver(function () {
    if (fixing || pending) return; pending = true;
    (window.requestAnimationFrame || setTimeout)(function () { pending = false; fixDynamic(); revealScan(); });
  });
  mo.observe(du, { childList: true, subtree: true, characterData: false });

  /* ------------------------------------------------------------------ language wiring */
  var origSet = window.duSetLang;
  var ASYNC = ["duToday", "duVerse", "duDuaList", "duNames99", "duNameOut", "duEvents", "duRam", "duPrayerOut", "duCal"];
  function lockHeights() {
    ASYNC.forEach(function (id) {
      var n = $(id); if (!n || !n.offsetHeight) return;
      n.style.minHeight = n.offsetHeight + "px"; n.classList.add("dxu-locked");
    });
    var t0 = Date.now();
    function release() {
      var busy = ASYNC.some(function (id) { var n = $(id); return n && n.querySelector(".du-loading"); });
      if (busy && Date.now() - t0 < 5000) return setTimeout(release, 150);
      ASYNC.forEach(function (id) { var n = $(id); if (n) { n.style.minHeight = ""; n.classList.remove("dxu-locked"); } });
    }
    setTimeout(release, 400);
  }
  // keep whatever the reader is looking at in the same place while texts re-render in the new language
  function pinReadingPosition() {
    var cands = du.querySelectorAll(".du-h,.du-group,.du-sec,.dxu-sechead,.du-hero"), anchor = null, best = 1e9;
    for (var i = 0; i < cands.length; i++) {
      var r = cands[i].getBoundingClientRect();
      if (r.bottom > 0 && Math.abs(r.top) < best) { best = Math.abs(r.top); anchor = cands[i]; }
    }
    if (!anchor || window.pageYOffset < 50) return;
    var top0 = anchor.getBoundingClientRect().top, t0 = Date.now(), stop = false;
    function cancel() { stop = true; ["wheel", "touchstart", "keydown", "pointerdown"].forEach(function (ev) { window.removeEventListener(ev, cancel, true); }); }
    ["wheel", "touchstart", "keydown", "pointerdown"].forEach(function (ev) { window.addEventListener(ev, cancel, { capture: true, passive: true }); });
    (function keep() {
      if (stop) return;
      var d = anchor.getBoundingClientRect().top - top0;
      if (Math.abs(d) > 1) window.scrollBy(0, d);
      if (Date.now() - t0 < 3500) (window.requestAnimationFrame || setTimeout)(keep); else cancel();
    })();
  }
  function setLang(l) {
    l = l === 1 ? 1 : 0;
    if (l === L() && du.getAttribute("lang")) { applyStatic(); return; }
    lockHeights();
    pinReadingPosition();
    du.classList.add("dxu-swap");
    if (typeof origSet === "function") origSet(l); else window.duLang = l;
    setTimeout(function () { du.classList.remove("dxu-swap"); }, 260);
    toast(t("langSet"));
    try { localStorage.setItem("quran-lang", l ? "ms" : "en"); localStorage.setItem("duLang", String(l)); } catch (e) {}
    applyStatic(); fixDynamic();
  }
  window.duSetLang = setLang;
  // the original buttons use inline onclick="duSetLang(n)" which now resolves to setLang
  function syncFromStorage() {
    var q = null; try { q = localStorage.getItem("quran-lang"); } catch (e) {}
    if (q !== "ms" && q !== "en") return;
    var want = q === "ms" ? 1 : 0;
    if (want !== L()) setLang(want);
  }
  window.addEventListener("storage", function (e) { if (e.key === "quran-lang") syncFromStorage(); });
  window.addEventListener("pageshow", function (e) { if (e.persisted) syncFromStorage(); });

  /* ------------------------------------------------------------------ smooth jumps + scroll-spy */
  function headH() {
    var h = document.querySelector(".section-header");
    if (!h) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? Math.max(0, Math.round(r.bottom)) : 0;
  }
  function setOffsets() {
    var hh = headH();
    document.documentElement.style.setProperty("--dxu-head", hh + "px");
  }
  function jumpTo(id) {
    var tgt = $(id); if (!tgt) return;
    var navH = nav ? nav.getBoundingClientRect().height : 0;
    var y = tgt.getBoundingClientRect().top + window.pageYOffset - headH() - navH - 20;
    window.scrollTo({ top: Math.max(0, y), behavior: RM ? "auto" : "smooth" });
    tgt.setAttribute("tabindex", "-1");
    try { tgt.focus({ preventScroll: true }); } catch (e) {}
  }
  du.addEventListener("click", function (e) {
    var a = e.target.closest("[data-jump]");
    if (!a || !du.contains(a)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    jumpTo(a.getAttribute("data-jump"));
  }, true);
  if (topBtn) topBtn.addEventListener("click", function (e) { e.stopImmediatePropagation(); window.scrollTo({ top: 0, behavior: RM ? "auto" : "smooth" }); }, true);

  var chips = nav ? Array.prototype.slice.call(nav.querySelectorAll(".du-navchip[data-jump]")) : [];
  var spyT = 0;
  function spy() {
    spyT = 0; setOffsets();
    if (!chips.length) return;
    var line = headH() + (nav ? nav.getBoundingClientRect().height : 0) + 60, cur = null;
    chips.forEach(function (c) { var s = $(c.getAttribute("data-jump")); if (s && s.getBoundingClientRect().top <= line) cur = c; });
    chips.forEach(function (c) { var on = c === cur; c.classList.toggle("dxu-cur", on); if (on) c.setAttribute("aria-current", "true"); else c.removeAttribute("aria-current"); });
    if (cur && nav && nav.scrollWidth > nav.clientWidth) {
      var nl = cur.offsetLeft - nav.offsetLeft, want = nl - (nav.clientWidth - cur.offsetWidth) / 2;
      if (Math.abs(nav.scrollLeft - want) > 24) nav.scrollTo({ left: want, behavior: RM ? "auto" : "smooth" });
    }
    if (nav) nav.classList.toggle("dxu-stuck", nav.getBoundingClientRect().top <= headH() + 12);
  }
  window.addEventListener("scroll", function () { if (!spyT) spyT = (window.requestAnimationFrame || setTimeout)(spy); }, { passive: true });
  window.addEventListener("resize", spy);

  /* ------------------------------------------------------------------ reveal */
  var io = null;
  if (!RM && "IntersectionObserver" in window) {
    du.classList.add("dxu-anim");
    io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("dxu-in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.04 });
  }
  function revealScan() {
    if (!io) return;
    du.querySelectorAll(".dxu-rv:not(.dxu-in):not([data-dxu-io])").forEach(function (n) { n.setAttribute("data-dxu-io", "1"); io.observe(n); });
  }
  // safety net: never leave content hidden (e.g. print, very tall sections)
  setTimeout(function () { du.querySelectorAll(".dxu-rv").forEach(function (n) { var r = n.getBoundingClientRect(); if (r.top < window.innerHeight) n.classList.add("dxu-in"); }); }, 1200);
  window.addEventListener("beforeprint", function () { du.querySelectorAll(".dxu-rv").forEach(function (n) { n.classList.add("dxu-in"); }); });

  // keyboard access for 99 Names cards
  du.addEventListener("keydown", function (e) {
    var c = e.target.closest && e.target.closest(".du-n99 .c");
    if (c && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); c.click(); }
  });
  du.addEventListener("click", function (e) {
    var c = e.target.closest && e.target.closest(".du-n99 .c");
    if (c) c.setAttribute("aria-expanded", c.classList.contains("on") ? "true" : "false");
  });

  /* ------------------------------------------------------------------ instant data: idle + intent prefetch */
  var C = window.dxuCache;
  function apiU(p) { return "https://ummahapi.com/api/" + p; }
  function coords() { try { var c = JSON.parse(localStorage.getItem("du_coords") || "null"); return c && isFinite(c.lat) && isFinite(c.lng) ? c : null; } catch (e) { return null; } }
  function methodNow() { try { return window.duMethod(window.duTz())[0]; } catch (e) { return "MuslimWorldLeague"; } }
  var PF = {
    dua: function () { return [apiU("duas")].concat((window.duDuaCats || []).map(function (c) { return apiU("duas/category/" + c.id); })); },
    names: function () { return (window.duNameSet || []).map(function (x) { return apiU("names/" + x.id); }); },
    n99: function () { return [apiU("asma-ul-husna")]; },
    today: function () { return [apiU("today-hijri"), apiU("moon")]; },
    events: function () { return [apiU("islamic-events")]; },
    prayer: function () { var c = coords(); return c ? [apiU("prayer-times?lat=" + c.lat + "&lng=" + c.lng + "&method=" + methodNow()), apiU("qibla?lat=" + c.lat + "&lng=" + c.lng)] : []; },
    cities: function () { return CITIES.map(function (c) { return apiU("prayer-times?lat=" + c[2] + "&lng=" + c[3] + "&method=" + (c[0] === "sg" ? "Singapore" : "JAKIM")); }); },
    verse: function () { if (C) C.prefetchVerses(); return []; }
  };
  var SEC2PF = { "sec-today": ["today"], "sec-prayer": ["prayer"], "sec-verse": ["verse"], "sec-dua": ["dua"], "sec-99": ["n99"], "sec-names": ["names"], "sec-events": ["events"], "sec-ramadan": ["prayer"] };
  function prefetch(keys) {
    if (!C) return;
    var urls = [];
    keys.forEach(function (k) { if (PF[k]) urls = urls.concat(PF[k]()); });
    if (urls.length) C.prefetch(urls);
  }
  var pagePf = {};
  function prefetchPage(href) {
    var u = href.split("#")[0];
    if (pagePf[u] || !/^\/pages\/digital-(quran|hadith)/.test(u)) return;
    pagePf[u] = 1;
    var l = document.createElement("link"); l.rel = "prefetch"; l.href = u; l.as = "document";
    document.head.appendChild(l);
  }
  function intent(e) {
    var a = e.target.closest && e.target.closest("[data-jump],a[href^='/pages/digital-'],#dxuCity,.dxu-select");
    if (!a || !du.contains(a)) return;
    if (a.id === "dxuCity" || a.classList.contains("dxu-select")) return prefetch(["cities"]);
    var j = a.getAttribute("data-jump");
    if (j && SEC2PF[j]) prefetch(SEC2PF[j]);
    var h = a.getAttribute("href"); if (h && h.charAt(0) === "/") prefetchPage(h);
  }
  ["pointerover", "touchstart", "focusin"].forEach(function (ev) { du.addEventListener(ev, intent, { passive: true }); });
  // at idle, warm everything below the fold so every tap is instant
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(function () { fn({ timeRemaining: function () { return 10; } }); }, 1); };
  function warm() { prefetch(["dua", "names", "verse", "prayer", "n99", "events", "today"]); }
  if (document.readyState === "complete") idle(warm, { timeout: 4000 }); else window.addEventListener("load", function () { idle(warm, { timeout: 4000 }); });

  /* ------------------------------------------------------------------ boot */
  applyStatic();
  fixDynamic();
  revealScan();
  spy();
  // the hero chips depend on date only; refresh once at midnight-ish
  setInterval(renderLive, 10 * 60 * 1000);
})();
